import { AxiosResponse } from 'axios'
import httpService from '../httpService'
import { Language } from '../redux/languages/types'
const getLanguages = (): Promise<AxiosResponse<Language[]>> => {
  return httpService.get('/v4/content/sources/languages/')
}
export default getLanguages
